import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Grid,
  CircularProgress,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: '100%'
  },
  innerWrapper: {
    width: '368px',
    textAlign: 'center',
    alignItems: 'center',
    padding: theme.spacing(2, 1)
  },
}));

const LoadingPage = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.wrapper}>
      <Grid container direction="column" className={classes.innerWrapper} component="main">
        <CircularProgress />
        <p>{t('common:loading')}...</p>
      </Grid>
    </Grid>
  );
}

export default LoadingPage;
